import React, { useContext } from "react";
import classes from "./Sidebar.module.scss";
import GoalContext from "../../store/goal-context";
import GoalItem from "../GoalItem/GoalItem";
import mobileLogoSustainable from "../../assets/dundee-sustainable-logo-colour.svg";
import mobileLogoGoals from "../../assets/sustainable-development-goal-horizontal.svg";

const Sidebar = (props) => {
  const goalContext = useContext(GoalContext);
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  console.log(goalContext);

  const resetMap = () => {
    goalContext.activeMapInstance.instance.zoom = 13;
    goalContext.activeMapInstance.instance.panTo({
      lat: 56.4746004,
      lng: -2.9668333,
    });
  }

  const cancelGoal = () => {
    document.body.classList.remove("goal-open");
    goalContext.setActiveLocation(null);
    goalContext.setActiveMarker(null);
    goalContext.setActiveGoal(null);
    window.history.replaceState(null, '', '/');
    resetMap();
  }

  const closeGoalHandler = () => {
    cancelGoal();
  };

  const activeGoalHandler = (id) => {
    document.body.classList.add("goal-open");
    goalContext.setActiveGoal(id);
    goalContext.setActiveLocation(null);
    goalContext.setActiveMarker(null);
    if(viewportWidth > 992) {
      setTimeout(() => {
        const locationAnchor = document.querySelector(`#location-0`);
        locationAnchor.scrollIntoView({
          behavior: 'auto'
        });
      }, 500)
    }
    window.history.replaceState(null, '', '/goal/' + id + '/');
    resetMap();

    if(goalContext.activeGoal === id) {
      console.log('matched');
      cancelGoal();
    }
  };

  return (
        <section className={classes.sidebar}>
          <div className={classes["logo-holder"]} onClick={closeGoalHandler}>
            <img
              src={mobileLogoSustainable}
              alt="Sustainable Development Goals"
              className={classes["primary-logo"]}
            />
            <img
              src={mobileLogoGoals}
              alt="Sustainable Development Goals"
              className={classes["secondary-logo"]}
            />
            <div className={classes["desktop-instuctions"]}>Select a goal to explore</div>
          </div>
          <div className={classes["mobile-instuctions"]}>Tap on a goal to see what we are doing in Dundee</div>
          <ul className={classes["goal-items"]}>
            {goalContext.goals.map((goal) => (
              <GoalItem
                key={goal.number}
                id={goal.number}
                name={goal.short_title}
                colour={goal.primary_colour}
                onClick={activeGoalHandler.bind("SET", parseInt(goal.number))}
                primaryImage={goal.goal_desktop_image}
                goal={goal.number}
              />
            ))}
          </ul>
        </section>
  );
};

export default Sidebar;
